export default "__VITE_ASSET__d8a4af9b__"